import styled, { css } from 'styled-components';
import { evoLoadAnimation } from '@/app/components/search/styles/mixins.ts';

export const LoadersContainer = styled.div`
  width: 100%;
`;

export const Loader = styled.div<{
  elWidth?: number | string;
  elHeight?: number | string;
}>`
  background: ${({ theme }) => theme.kallisto.color.background.static.backgroundDisabled};
  position: relative;
  border-radius: 4px;
  clear: both;
  height: 16px;
  max-width: 100%;

  ${evoLoadAnimation};

  ${({ elWidth }) =>
    elWidth
      ? css`
          width: ${typeof elWidth === 'number' ? `${elWidth}px` : `${elWidth}`};
        `
      : css`
          width: 100%;
        `};

  ${({ elHeight }) =>
    elHeight &&
    css`
      height: ${typeof elHeight === 'number' ? `${elHeight}px` : `${elHeight}`};
    `};
`;
